import React, { useEffect, useState } from "react";
import { FiSearch, FiX, FiEye } from "react-icons/fi";
import api from "../../utils/api";

const Guard = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPass, setSelectedPass] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState({});
  const [notification, setNotification] = useState(null);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    // Get user role from localStorage
    const userItem = localStorage.getItem("user");
  
    if (userItem) {
      try {
        const user = JSON.parse(userItem);
        setUserRole(user?.role_name[0]);
        console.log(userRole);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const fetchData = async () => {
    try {
      const res = await api.get("/passes");
      const raw = res?.data?.data
      const stat=res?.data
      if (stat.status === "success" && stat?.data) {
        setData(raw);
        setFilteredData(raw);
      }
    } catch (error) {
      console.error("Error fetching passes:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((item) =>
        item.otp.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (item.guest_name && item.guest_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.delivery_service && item.delivery_service.toLowerCase().includes(searchQuery.toLowerCase()))
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, data]);

  const handleCheckIn = async (id) => {
  setLoading(prev => ({ ...prev, [id]: true }));

  try {
    const response = await api.patch(`/passes/${id}/check-in`);
    const result = response.data; // axios gives data directly in response.data

    if (result.status === "success") {
      setNotification({
        type: "success",
        message: result.message || "Checked in successfully!"
      });

      // Auto-hide notification after 4 seconds
      setTimeout(() => setNotification(null), 4000);

      // Refresh data
      await fetchData();
    } else {
      throw new Error(result.message || "Check-in failed");
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message || "Failed to check in";
    setNotification({
      type: "error",
      message: errorMsg
    });
    setTimeout(() => setNotification(null), 5000);
    console.error("Error checking in:", error);
  } finally {
    setLoading(prev => ({ ...prev, [id]: false }));
  }
};

const handleCheckOut = async (id) => {
  setLoading(prev => ({ ...prev, [id]: true }));

  try {
    const response = await api.patch(`/passes/${id}/check-out`);
    const result = response.data;

    if (result.status === "success") {
      setNotification({
        type: "success",
        message: result.message || "Checked out successfully!"
      });
      setTimeout(() => setNotification(null), 4000);
      await fetchData();
    } else {
      throw new Error(result.message || "Check-out failed");
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message || "Failed to check out";
    setNotification({
      type: "error",
      message: errorMsg
    });
    setTimeout(() => setNotification(null), 5000);
    console.error("Error checking out:", error);
  } finally {
    setLoading(prev => ({ ...prev, [id]: false }));
  }
};

  const handleViewPass = (pass) => {
    setSelectedPass(pass);
    setShowModal(true);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const formatTime = (timeString) => {
    const date = new Date(timeString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getPassTypeIcon = (type) => {
    switch (type) {
      case "guest":
        return "👤";
      case "delivery":
        return "📦";
      case "vehicle":
        return "🚗";
      default:
        return "👤";
    }
  };

  const PassModal = () => {
    if (!selectedPass) return null;
console.log("userRole in PassModal:", userRole);
    const isGuard = userRole === "admin";

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="w-full max-w-md max-h-[90vh] overflow-y-auto">
          {/* Header */}
          <div className="bg-white rounded-t-2xl px-6 py-4 flex items-center shadow-lg">
            <button
              onClick={() => setShowModal(false)}
              className="text-slate-700 hover:text-slate-900 transition-colors"
            >
              <FiX className="w-5 h-5" />
            </button>
            <h3 className="flex-1 text-center font-bold text-xl text-slate-800">
              Gate Entry Pass
            </h3>
            <div className="w-5"></div>
          </div>

          {/* Pass Content */}
          <div className="bg-white shadow-2xl">
            {/* Top Section with Gradient */}
            <div className="bg-gradient-to-br from-[#403F93] to-[#5B5AA8] px-6 py-8 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-40 h-40 bg-white opacity-5 rounded-full -mr-20 -mt-20"></div>
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-white opacity-5 rounded-full -ml-16 -mb-16"></div>

              <div className="relative z-10 text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4 backdrop-blur-sm">
                  <div className="text-3xl">{getPassTypeIcon(selectedPass.type)}</div>
                </div>
                <p className="text-white/80 text-xs uppercase tracking-widest mb-2 font-medium">
                  You are invited by
                </p>
                <h2 className="text-white text-2xl font-bold uppercase tracking-wide mb-1">
                  {selectedPass.invited_by}
                </h2>
                <p className="text-white/70 text-sm">to the Residency</p>
              </div>
            </div>

            {/* OTP Code Section */}
            <div className="px-6 -mt-8 relative z-20">
              <div className="bg-white rounded-2xl shadow-xl border-4 border-[#403F93] p-6">
                <p className="text-center text-xs text-slate-500 uppercase tracking-widest mb-3 font-semibold">
                  Entry Code
                </p>
                <div className="flex justify-center items-center gap-2 mb-2">
                  {selectedPass.otp.split("").map((digit, index) => (
                    <div
                      key={index}
                      className="w-10 h-12 bg-gradient-to-br from-[#403F93] to-[#5B5AA8] rounded-lg flex items-center justify-center shadow-md"
                    >
                      <span className="text-white text-2xl font-bold">
                        {digit}
                      </span>
                    </div>
                  ))}
                </div>
                <p className="text-center text-xs text-slate-400 mt-3">
                  Show this code at the gate
                </p>
              </div>
            </div>

            {/* Details Section */}
            <div className="px-6 py-6 space-y-4">
              {/* Pass Type Info */}
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#403F93] rounded-lg flex items-center justify-center text-white text-xl">
                    {getPassTypeIcon(selectedPass.type)}
                  </div>
                  <div className="flex-1">
                    <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold mb-1">
                      {selectedPass.type} Pass
                    </p>
                    <p className="text-sm font-semibold text-slate-800">
                      {selectedPass.type === "guest" && selectedPass.guest_name}
                      {selectedPass.type === "delivery" &&
                        `${selectedPass.delivery_service} - ${selectedPass.delivery_place}`}
                      {selectedPass.type === "vehicle" &&
                        `${selectedPass.vehicle_type} (${selectedPass.vehicle_number})`}
                    </p>
                  </div>
                </div>
              </div>

              {/* Date & Time */}
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold mb-2">
                    Date
                  </p>
                  <p className="text-sm font-bold text-slate-800">
                    {formatDate(selectedPass.date)}
                  </p>
                </div>
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold mb-2">
                    Time
                  </p>
                  <p className="text-sm font-bold text-slate-800">
                    {formatTime(selectedPass.visit_time)}
                  </p>
                </div>
              </div>

              {/* Purpose */}
              {selectedPass.purpose && (
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold mb-2">
                    Purpose
                  </p>
                  <p className="text-sm text-slate-700">{selectedPass.purpose}</p>
                </div>
              )}

              {/* Phone Number */}
              {selectedPass.phone_number && (
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold mb-2">
                    Contact
                  </p>
                  <p className="text-sm font-semibold text-slate-800">
                    {selectedPass.phone_number}
                  </p>
                </div>
              )}

              {/* Check-in/Check-out Status */}
              {isGuard && (
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold mb-2">
                        Checked In
                      </p>
                      <p className="text-sm font-bold text-slate-800">
                        {selectedPass.checked_in_at ? formatTime(selectedPass.checked_in_at) : "Not yet"}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold mb-2">
                        Checked Out
                      </p>
                      <p className="text-sm font-bold text-slate-800">
                        {selectedPass.checked_out_at ? formatTime(selectedPass.checked_out_at) : "Not yet"}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Status Badge */}
              <div className="flex items-center justify-center gap-2 pt-2">
                <div className={`w-2 h-2 rounded-full animate-pulse ${
                  selectedPass.status === "pending" ? "bg-yellow-500" : 
                  selectedPass.status === "approved" ? "bg-green-500" : "bg-red-500"
                }`}></div>
                <span className={`text-xs font-semibold uppercase tracking-wide ${
                  selectedPass.status === "pending" ? "text-yellow-600" : 
                  selectedPass.status === "approved" ? "text-green-600" : "text-red-600"
                }`}>
                  {selectedPass.status}
                </span>
              </div>
            </div>

            {/* Footer Design */}
            <div className="bg-slate-50 px-6 py-4 border-t-2 border-dashed border-slate-300 rounded-b-2xl">
              <p className="text-center text-xs text-slate-500">
                Valid for single entry • Non-transferable
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex justify-center  bg-slate-200 w-full min-h-screen pt-8 pb-[7rem]">
      {/* Notification Toast */}
      {notification && (
        <div className={`fixed top-4 right-4 z-50 px-6 py-4 rounded-lg shadow-lg transform transition-all duration-300 ${
          notification.type === "success" 
            ? "bg-green-500 text-white" 
            : "bg-red-500 text-white"
        }`}>
          <div className="flex items-center gap-3">
            {notification.type === "success" ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
            <span className="font-semibold">{notification.message}</span>
          </div>
        </div>
      )}

      <div className="w-full max-w-7xl bg-white rounded-lg shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h3 className="font-bold text-2xl text-slate-800">
            Security Check
          </h3>
          <div className="relative">
            <FiSearch className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Search by OTP or name..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#403F93] focus:border-transparent"
            />
          </div>
        </div>

        {/* Table */}
        <div className="px-6 py-4 overflow-x-auto">
          <table className="w-full border border-slate-300">
            <thead className="bg-slate-100">
              <tr>
                <th className="border border-slate-300 px-4 py-3 text-left text-sm font-semibold">
                  OTP
                </th>
                <th className="border border-slate-300 px-4 py-3 text-left text-sm font-semibold">
                  Type
                </th>
                <th className="border border-slate-300 px-4 py-3 text-left text-sm font-semibold">
                  Name/Details
                </th>
                <th className="border border-slate-300 px-4 py-3 text-left text-sm font-semibold">
                  Visit Time
                </th>
                {userRole === "guard" && (
                  <>
                    <th className="border border-slate-300 px-4 py-3 text-center text-sm font-semibold">
                      Checked In
                    </th>
                    <th className="border border-slate-300 px-4 py-3 text-center text-sm font-semibold">
                      Checked Out
                    </th>
                  </>
                )}
                <th className="border border-slate-300 px-4 py-3 text-center text-sm font-semibold">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item) => (
                <tr key={item.id} className="hover:bg-slate-50 transition-colors">
                  <td className="border border-slate-300 px-4 py-3 text-center font-mono font-bold text-[#403F93]">
                    {item.otp}
                  </td>
                  <td className="border border-slate-300 px-4 py-3">
                    <span className="inline-flex items-center gap-1 text-sm">
                      <span className="text-lg">{getPassTypeIcon(item.type)}</span>
                      <span className="capitalize">{item.type}</span>
                    </span>
                  </td>
                  <td className="border border-slate-300 px-4 py-3 text-sm">
                    {item.type === "guest" && item.guest_name}
                    {item.type === "delivery" && `${item.delivery_service} - ${item.delivery_place}`}
                    {item.type === "vehicle" && `${item.vehicle_type} (${item.vehicle_number})`}
                  </td>
                  <td className="border border-slate-300 px-4 py-3 text-sm">
                    {formatTime(item.visit_time)}
                  </td>
                  {userRole === "guard" && (
                    <>
                      <td
                        className={`border border-slate-300 px-4 py-3 text-center ${
                          !item.checked_in_at && !loading[item.id]
                            ? "cursor-pointer hover:bg-green-50"
                            : "cursor-not-allowed"
                        } transition-colors`}
                        onClick={() => !item.checked_in_at && !loading[item.id] && handleCheckIn(item.id)}
                      >
                        {loading[item.id] ? (
                          <div className="flex justify-center">
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#403F93]"></div>
                          </div>
                        ) : item.checked_in_at ? (
                          <span className="text-xs text-green-700 font-semibold">
                            {formatTime(item.checked_in_at)}
                          </span>
                        ) : (
                          <svg
                            width="22"
                            height="20"
                            viewBox="0 0 22 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="mx-auto"
                          >
                            <path
                              d="M20.75 0H1.25C1.05109 0 0.860322 0.0526785 0.71967 0.146447C0.579018 0.240215 0.5 0.367392 0.5 0.5V9H9.5V6L17 10L9.5 14V11H0.5V19.5C0.5 19.6326 0.579018 19.7598 0.71967 19.8536C0.860322 19.9473 1.05109 20 1.25 20H20.75C20.9489 20 21.1397 19.9473 21.2803 19.8536C21.421 19.7598 21.5 19.6326 21.5 19.5V0.5C21.5 0.367392 21.421 0.240215 21.2803 0.146447C21.1397 0.0526785 20.9489 0 20.75 0Z"
                              fill="#50B748"
                            />
                          </svg>
                        )}
                      </td>
                      <td
                        className={`border border-slate-300 px-4 py-3 text-center ${
                          item.checked_in_at && !item.checked_out_at && !loading[item.id]
                            ? "cursor-pointer hover:bg-red-50"
                            : "cursor-not-allowed opacity-50"
                        } transition-colors`}
                        onClick={() => item.checked_in_at && !item.checked_out_at && !loading[item.id] && handleCheckOut(item.id)}
                      >
                        {loading[item.id] ? (
                          <div className="flex justify-center">
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#BE4B27]"></div>
                          </div>
                        ) : item.checked_out_at ? (
                          <span className="text-xs text-red-700 font-semibold">
                            {formatTime(item.checked_out_at)}
                          </span>
                        ) : (
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="mx-auto"
                          >
                            <path
                              d="M18.4999 0H1.49992C1.1242 0 0.763861 0.105357 0.498184 0.292893C0.232508 0.48043 0.083252 0.734784 0.083252 1V10L7.16658 6V9H15.6666V11H7.16658V14L0.083252 10V19C0.083252 19.2652 0.232508 19.5196 0.498184 19.7071C0.763861 19.8946 1.1242 20 1.49992 20H18.4999C18.8756 20 19.236 19.8946 19.5017 19.7071C19.7673 19.5196 19.9166 19.2652 19.9166 19V1C19.9166 0.734784 19.7673 0.48043 19.5017 0.292893C19.236 0.105357 18.8756 0 18.4999 0Z"
                              fill="#BE4B27"
                            />
                          </svg>
                        )}
                      </td>
                    </>
                  )}
                  <td className="border border-slate-300 px-4 py-3 text-center">
                    <button
                      onClick={() => handleViewPass(item)}
                      className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#403F93] text-white rounded-lg hover:bg-[#5B5AA8] transition-colors text-sm font-semibold"
                    >
                      <FiEye className="w-4 h-4" />
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filteredData.length === 0 && (
            <div className="text-center py-8 text-slate-500">
              No passes found
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && <PassModal />}
    </div>
  );
};

export default Guard;